import { render } from "./CreateInventory.vue?vue&type=template&id=aee81a62&scoped=true"
import script from "./CreateInventory.vue?vue&type=script&lang=js"
export * from "./CreateInventory.vue?vue&type=script&lang=js"

import "./CreateInventory.vue?vue&type=style&index=0&id=aee81a62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aee81a62"]])

export default __exports__